import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const GeofenceDrawer = ({ onGeofenceCreated, onGeofenceDeleted }) => {
  const map = useMap();
  const drawnItemsRef = useRef(new L.FeatureGroup());
  const drawControlRef = useRef(null);

  useEffect(() => {
    // Add the drawn items layer to the map
    map.addLayer(drawnItemsRef.current);

    // Initialize the draw control
    drawControlRef.current = new L.Control.Draw({
      position: 'topright',
      draw: {
        polygon: {
          allowIntersection: false,
          showArea: true,
          drawError: {
            color: '#e1e100',
            message: '<strong>Error:</strong> shape edges cannot cross!'
          },
          shapeOptions: {
            color: '#004aad',
            fillColor: '#004aad',
            fillOpacity: 0.2,
            weight: 2
          }
        },
        polyline: false,
        rectangle: false,
        circle: false,
        marker: false,
        circlemarker: false
      },
      edit: {
        featureGroup: drawnItemsRef.current,
        remove: true
      }
    });

    // Add the draw control to the map
    map.addControl(drawControlRef.current);

    // Handle draw events
    const handleDrawCreated = (e) => {
      const { layerType, layer } = e;
      
      if (layerType === 'polygon') {
        // Get the polygon coordinates
        const coordinates = layer.getLatLngs()[0].map(latlng => ({
          lat: latlng.lat,
          lng: latlng.lng
        }));

        // Call the callback with the polygon data
        onGeofenceCreated({
          id: `geofence_${Date.now()}`,
          coordinates: coordinates,
          type: 'polygon',
          layer: layer
        });
      }
    };

    const handleDrawEdited = (e) => {
      const layers = e.layers;
      layers.eachLayer((layer) => {
        if (layer instanceof L.Polygon) {
          const coordinates = layer.getLatLngs()[0].map(latlng => ({
            lat: latlng.lat,
            lng: latlng.lng
          }));
          
          onGeofenceCreated({
            id: `geofence_${Date.now()}`,
            coordinates: coordinates,
            type: 'polygon',
            layer: layer
          });
        }
      });
    };

    const handleDrawDeleted = (e) => {
      // Handle deletion - remove from local state
      const layers = e.layers;
      layers.eachLayer((layer) => {
        if (layer instanceof L.Polygon) {
          // Find and remove the geofence from local state
          if (onGeofenceDeleted) {
            onGeofenceDeleted({
              id: `delete_${Date.now()}`,
              action: 'delete',
              layer: layer
            });
          } else {
            // Fallback to old method
            onGeofenceCreated({
              id: `delete_${Date.now()}`,
              action: 'delete',
              layer: layer
            });
          }
        }
      });
    };

    // Add event listeners
    map.on(L.Draw.Event.CREATED, handleDrawCreated);
    map.on(L.Draw.Event.EDITED, handleDrawEdited);
    map.on(L.Draw.Event.DELETED, handleDrawDeleted);

    // Cleanup function
    return () => {
      const drawControl = drawControlRef.current;
      const drawnItems = drawnItemsRef.current;
      
      if (drawControl) {
        map.removeControl(drawControl);
      }
      if (drawnItems) {
        map.removeLayer(drawnItems);
      }
      
      map.off(L.Draw.Event.CREATED, handleDrawCreated);
      map.off(L.Draw.Event.EDITED, handleDrawEdited);
      map.off(L.Draw.Event.DELETED, handleDrawDeleted);
    };
  }, [map, onGeofenceCreated, onGeofenceDeleted]);

  return null; // This component doesn't render anything visible
};

export default GeofenceDrawer;
